"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = __importStar(require("styled-components"));
var __1 = require("../../..");
var utils_1 = require("../../../utils/utils");
var chroma_js_1 = __importDefault(require("chroma-js"));
var basicColorStyle = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n"], ["\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme, $isActive = _a.$isActive;
    return $isActive
        ? theme.white
        : (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__outlineButtonColor, theme.outlineButtonColor, theme.primaryColor);
});
var ListComponent = styled_components_1.default.ul(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding: 0px;\n"], ["\n  display: flex;\n  flex-direction: column;\n  list-style: none;\n  padding: 0px;\n"])));
var ListItem = styled_components_1.default.li(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 10px;\n  gap: 10px;\n  transition: 0.3s;\n  background-color: ", ";\n  cursor: pointer;\n  &:hover {\n    transform: scale(1.05);\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 10px;\n  gap: 10px;\n  transition: 0.3s;\n  background-color: ", ";\n  cursor: pointer;\n  &:hover {\n    transform: scale(1.05);\n  }\n"])), function (_a) {
    var theme = _a.theme, $isActive = _a.$isActive;
    return $isActive ? (0, chroma_js_1.default)(theme.primaryColor).darken().hex() : "transparent";
});
var StyledText = (0, styled_components_1.default)(__1.Text)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: 14px;\n  font-weight: ", ";\n  ", "\n"], ["\n  font-size: 14px;\n  font-weight: ", ";\n  ", "\n"])), function (_a) {
    var $isActive = _a.$isActive;
    return ($isActive ? "bold" : "normal");
}, basicColorStyle);
var StyledIconText = (0, styled_components_1.default)(__1.IconText)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  * {\n    font-weight: ", ";\n    ", "\n  }\n  svg {\n    fill: ", " !important;\n  }\n"], ["\n  * {\n    font-weight: ", ";\n    ", "\n  }\n  svg {\n    fill: ", " !important;\n  }\n"])), function (_a) {
    var $isActive = _a.$isActive;
    return ($isActive ? "bold" : "normal");
}, basicColorStyle, function (_a) {
    var theme = _a.theme, $isActive = _a.$isActive;
    return $isActive
        ? theme.white
        : (0, utils_1.getStylesBasedOnTheme)(theme.mode, theme.dm__outlineButtonColor, theme.outlineButtonColor, theme.primaryColor);
});
var List = function (_a) {
    var listItems = _a.listItems, selectedListItem = _a.selectedListItem, setSelectedListItem = _a.setSelectedListItem, props = __rest(_a, ["listItems", "selectedListItem", "setSelectedListItem"]);
    return ((0, jsx_runtime_1.jsx)(ListComponent, __assign({ "data-testid": "list" }, props, { children: listItems.map(function (_a) {
            var id = _a.id, icon = _a.icon, text = _a.text, numberOfItems = _a.numberOfItems;
            return ((0, jsx_runtime_1.jsxs)(ListItem, __assign({ "$isActive": selectedListItem === id, "data-testid": text, onClick: function () { return setSelectedListItem(id); } }, { children: [(0, jsx_runtime_1.jsx)(StyledIconText, { icon: icon, text: text, noMargin: true, "$isActive": selectedListItem === id }), (0, jsx_runtime_1.jsx)(StyledText, __assign({ "$isActive": selectedListItem === id }, { children: numberOfItems }))] }), id));
        }) })));
};
exports.default = (0, styled_components_1.withTheme)((0, styled_components_1.default)(List)(templateObject_6 || (templateObject_6 = __makeTemplateObject([""], [""]))));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
